var render, staticRenderFns
import script from "./ContentCardGhostLoader.vue?vue&type=script&lang=tsx"
export * from "./ContentCardGhostLoader.vue?vue&type=script&lang=tsx"
import style0 from "./ContentCardGhostLoader.vue?vue&type=style&index=0&id=41faf110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41faf110",
  null
  
)

export default component.exports